import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appFormControlErrorContainer]'
})
export class FormErrorContainerDirective {

  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
